import { type Board, type BoardAncestors } from '@air/api/types';

import { type WorkspaceAgentBoardMentionItem } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/types';

/**
 * Structural minimum, so tests can pass a plain object. `ancestors` / `thumbnails` / `coverImage` /
 * `directDescendantBoardCount` are optional because `Boards.list` only returns them for matching options.
 */
export type WorkspaceAgentBoardMentionSource = Pick<Board, 'id' | 'title'> & {
  ancestors?: BoardAncestors;
  coverImage?: Pick<NonNullable<Board['coverImage']>, 'url'>;
  directDescendantBoardCount?: number;
  library?: Board['library'];
  thumbnails?: string[];
};

/**
 * The board on its own, with nothing about where it sits: searching lists boards flat, and the tree
 * adds the placement to the rows it draws.
 */
export const toWorkspaceAgentBoardMentionItem = (
  board: WorkspaceAgentBoardMentionSource,
): WorkspaceAgentBoardMentionItem => ({
  ancestors: board.ancestors ?? [],
  boardId: board.id,
  /** `||`: an empty cover url falls through to a thumbnail. */
  coverImageUrl: board.coverImage?.url || board.thumbnails?.[0] || null,
  id: board.id,
  kind: 'board',
  library: board.library,
  title: board.title,
});
